import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EmailPackagePage } from './email-package';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '../../components/components.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    EmailPackagePage,
  ],
  imports: [
    IonicPageModule.forChild(EmailPackagePage),
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule
  ],
})
export class EmailPackagePageModule {}



// WEBPACK FOOTER //
// ./src/pages/email-package/email-package.module.ts